module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upload-container"
  }, [_c('el-button', {
    style: ({
      background: _vm.color,
      borderColor: _vm.color
    }),
    attrs: {
      "icon": "el-icon-upload",
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  }, [_vm._v("\n    上传图片\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "test"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('el-upload', {
    staticClass: "editor-slide-upload",
    attrs: {
      "multiple": true,
      "file-list": _vm.fileList,
      "show-file-list": true,
      "on-remove": _vm.handleRemove,
      "on-success": _vm.handleSuccess,
      "before-upload": _vm.beforeUpload,
      "action": _vm.actionurl,
      "list-type": "picture-card"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("\n        点击上传\n      ")])], 1), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("\n      取消\n    ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    }
  }, [_vm._v("\n      确定\n    ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7f6a033b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tinymce/components/EditorImage.vue
// module id = 409
// module chunks = 1